import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AnnuityListViewModel, AnnuityViewModel } from '../../../models/annuity-view.model';
import { ManageService } from '../../../services/manage.service';
import { TablefilterMultiplePipe } from '../../../shared/pipes/tablefilter-multiple.pipe';
import { Sort } from "@angular/material/sort";
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { FileService } from '../../../services/file.service';
import { AuthService } from '../../../services/auth.service';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { Observable, merge } from 'rxjs';
import { CommonService } from '../../../services';
import { isNullOrUndefined } from '../../../shared/tools.collections';


@Component({
    selector: "app-manage-cirrus",
    templateUrl: "./manage-cirrus.component.html",
    styleUrls: ["./manage-cirrus.component.css"],
})
export class ManageCirrusComponent implements OnInit, OnDestroy {
    @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;
    pageView: string = 'PROGRAMS';

    programType: string = 'VDC';

    programName: string;

    model: AnnuityListViewModel;

    annuities: AnnuityViewModel[];

    sortedData: AnnuityViewModel[];
    // search
    searchField: string;

    expiryStart = '';

    expiryEnd = '';

    logoURL = "";

    longDescription = "";

    totalItems = 0;

    totalEndUser = 0;

    totalPending = 0;

    totalCancelled = 0;

    hasEmptyFilterResult = false;

    filterResultArr: any;

    loadContent = false;

    finishLoading = true;

    narrowMode = false;

    showDownload = true;

    ngUnsubscribe: Subject<void> = new Subject<void>();

    currentUserModel: CurrentUserModel;
    // export excel
    url: string;

    keyword: string;

    expiryStartDate: string;

    expiryEndDate: string;

    constructor
        (private manageService: ManageService,
            private router: Router,
            private activatedroute: ActivatedRoute,
            private fileService: FileService,
            private authService: AuthService,
            private commonService: CommonService
        ) {
        const vendorDetais = JSON.parse(
            localStorage.getItem("subscriptionVendor")
        );
        if (vendorDetais.length) {
            const filteredVendor = vendorDetais.filter(
                (x) => x.programType === this.programType
            );

            if (filteredVendor.length) {
                this.programName = filteredVendor[0].programName;
            }
        }
    }

    ngOnInit() {

        this.authService.getLoginInfo().subscribe(
            (res: CurrentUserModel) => {
                this.currentUserModel = res;
            },
            (error: any) => {
                console.error(error);
            }
        );

      this.narrowMode = this.router.url != `/manageSubscriptions/${this.programType}`;

      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((event: NavigationEnd) => {
          this.narrowMode = this.router.url != `/manageSubscriptions/${this.programType}`;
        });

        const subscriptionOrders$: Observable<AnnuityListViewModel> = this.manageService.getSubscriptionOrders(
            this.pageView,
            this.programType,
            this.expiryStart,
            this.expiryEnd
        );


        const update$ = this.manageService.getOrRefreshSubscriptionOrderSubject.asObservable().pipe(
            switchMap(() => subscriptionOrders$));


        merge(subscriptionOrders$, update$).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (value: AnnuityListViewModel) => {
                this.model = value;
                this.loadContent = true;
                if (
                    value != null &&
                    value.orders != null &&
                    value.orders.length > 0
                ) {
                    this.annuities = value.orders;
                    this.annuities.forEach((annuity) => {
                        annuity.priceLoadingStatus = false;
                    });
                    this.sortedData = this.annuities.slice();
                    this.totalItems = this.annuities.length;
                    this.totalEndUser = this.annuities.length;
                    this.totalPending = this.annuities.filter(
                        (x) => x.status.indexOf("Pending") !== -1
                    ).length;
                    this.totalCancelled = this.annuities.filter(
                        (x) => x.status.indexOf("Cancelled") !== -1
                    ).length;
                } else {
                    this.annuities = [];
                    this.sortedData = [];
                    this.totalItems = 0;
                    this.showDownload = false;
                }
                // this.showPager = this.totalItems > this.itemsPerPage ? true : false;
                this.longDescription = value.longDescription;
                if (!isNullOrUndefined(value.programLogo)) {
                    this.logoURL = value.programLogo;
                }
                this.commonService.applyScrollFixedHeader(this.parentWrapper);
            },
            (error: any) => {
                console.error(error);
                this.loadContent = true;
            }
        );;

    }

    exportExcelForAnnuities(): void {
        this.finishLoading = false;
        this.keyword = this.programType;
        this.manageService
            .exportExcelForAnnuities(this.keyword, this.pageView, "", "")
            .subscribe(
                (data: any) => {
                    const fileName = `Annuity Information ${this.currentUserModel.accountId}.xlsx`;
                    this.fileService.saveAsExcelFile(data, fileName);
                    this.finishLoading = true;
                },
                (error: any) => {
                    console.error(error);
                    this.loadContent = true;
                }
            );
    }

    isActive(annuityId: string): boolean {
        return this.router.url.includes(annuityId);
    }

    manageRedirect(annuity: AnnuityViewModel, detailsView: string): void {
        debugger;
        console.log('test');
        this.narrowMode = true;
        if (annuity.status === "Pending Billing Information") {
            this.router.navigate(
                [`CirrusDetails/${annuity.annuityId}/EditEndUser`],
                { relativeTo: this.activatedroute }
            );
        } else {
            this.router.navigate([`CirrusDetails/${annuity.annuityId}`], {
                relativeTo: this.activatedroute,
            });
        }
    }

    sortData(sort: Sort) {
        const data = this.annuities.slice();
        if (!sort.active || sort.direction === "") {
            this.sortedData = data;
            return;
        }

        this.sortedData = data.sort((a, b) => {
            const isAsc = sort.direction === "asc";
            switch (sort.active) {
                case "annuityId":
                    return compare(
                        a.annuityId.toLowerCase(),
                        b.annuityId.toLowerCase(),
                        isAsc
                    );
                case "endUserName":
                    return compare(
                        a.endUserName.toLowerCase(),
                        b.endUserName.toLowerCase(),
                        isAsc
                    );
                case "programType":
                    return compare(
                        a.programType.toLowerCase(),
                        b.programType.toLowerCase(),
                        isAsc
                    );
                case "nextOrderNo":
                    return compare(
                        a.nextOrderNo.toLowerCase(),
                        b.nextOrderNo.toLowerCase(),
                        isAsc
                    );
                case "currCustomerRef":
                    return compare(
                        a.currCustomerRef.toLowerCase(),
                        b.currCustomerRef.toLowerCase(),
                        isAsc
                    );
                case "lastBillingDate":
                    return compare(
                        this.dateFormat(a.lastBillingDate.toLowerCase())
                            .split("-")
                            .reverse()
                            .join("-"),
                        this.dateFormat(b.lastBillingDate.toLowerCase())
                            .split("-")
                            .reverse()
                            .join("-"),
                        isAsc
                    );
                case "billingDate":
                    return compare(
                        this.dateFormat(a.billingDate.toLowerCase())
                            .split("-")
                            .reverse()
                            .join("-"),
                        this.dateFormat(b.billingDate.toLowerCase())
                            .split("-")
                            .reverse()
                            .join("-"),
                        isAsc
                    );
                case "lastBillingAmount":
                    return compare(
                        parseFloat(a.lastBillingAmount),
                        parseFloat(b.lastBillingAmount),
                        isAsc
                    );
                case "totalAmount":
                    return compare(
                        parseFloat(a.totalAmount),
                        parseFloat(b.totalAmount),
                        isAsc
                    );
                case "status":
                    return compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
                default:
                    return 0;
            }
        });
    }

    dateFormat(date: any) {
        const month = {
            jan: "01",
            feb: "02",
            mar: "03",
            apr: "04",
            may: "05",
            jun: "06",
            jul: "07",
            aug: "08",
            sep: "09",
            oct: "10",
            nov: "11",
            dec: "12",
        };
        let formatedDate = date.split("-");
        formatedDate[1] = month[formatedDate[1]];
        formatedDate = formatedDate.join("-");
        return formatedDate;
    }

    onChange() {
        this.filterResultArr = new TablefilterMultiplePipe().transform(
            this.sortedData,
            [
                "endUserName",
                "currCustomerRef",
                "billingDate",
                "totalAmount",
                "status",
            ],
            this.searchField
        );
        if (this.filterResultArr.length === 0 && this.searchField !== "") {
            this.hasEmptyFilterResult = true;
        } else {
            this.hasEmptyFilterResult = false;
        }
        this.commonService.applyScrollFixedHeader(this.parentWrapper);
    }

    filterReset() {
        this.searchField = "";
        this.hasEmptyFilterResult = false;
    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }


    addCirrusNewEndUser(): void {
        this.narrowMode = true;
        this.router.navigate(["createCirrusEndUser"], {
            relativeTo: this.activatedroute,
        });
    }

    close() {
        this.router.navigateByUrl("/manageSubscriptions");
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
